import { IInputItems } from '@/typings';

export const tipoConsulta: IInputItems[] = [
  { label: '1 - Primeira Consulta', value: '1' },
  { label: '2 - Retorno', value: '2' },
  { label: '3 - Pré-natal', value: '3' },
  { label: '4 - Por encaminhamento', value: '4' },
];
